import React from 'react';
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Typography,
  withStyles,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import DeleteIcon from '@material-ui/icons/Delete';
import CircularProgress from '@material-ui/core/CircularProgress';

import swal from '@sweetalert/with-react';
import moment from 'moment';

import Autocomplete from '@material-ui/lab/Autocomplete';
import { speakerAction } from './SpeakerAction';
import { CountryList } from '../common/CountryList';
import axiosInstance, {
  EVENT_ID,
  F_EMAIL,
  titleCounter,
  wordCounter,
  paragraphCounter,
  focusElementRef,
  emailValidation,
  krMobileValidation,
  readFile,
  WEB_API,
  getUserID,
} from '../constatns';
import Table from '../components/Table/Table';
import ConfirmButton from '../components/Button/ConfirmButton';
import Editor from '../components/Editor';
import AgreementDiv from '../components/Div/AgreementDiv';
import FiguresUploadForm from '../components/FiguresUploadForm';
import SessionList from './SessionList.json';

const styles = (theme) => ({
  title: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    fontSize: '1.6em',
    textAlign: 'center',
    marginBottom: '0.5rem',
  },
  subTitle: {
    display: 'flex',
    fontSize: '1.2em',
    fontWeight: 'bold',
    marginBottom: '0.5rem',
    flexWrap: 'wrap',
  },
  table: {
    borderTop: `2px solid ${theme.palette.primary.main}`,
    '& tr th': {
      backgroundColor: '#f8f8f8',
      textAlign: 'center',
    },
  },
  asteriskMark: {
    color: 'rgb(255, 0, 0)',
  },
  tableInsideText: {
    fontSize: '1em',
  },
  inputLabelText: {
    fontSize: '1em',
    paddingBottom: '0.3em',
  },

  wordCounter: {
    backgroundColor: 'rgb(249, 249, 249)',
    borderBottom: '1px solid #c4c4c4',
    borderLeft: '1px solid #c4c4c4',
    borderRight: '1px solid #c4c4c4',
    borderBottomLeftRadius: '2px',
    borderBottomRightRadius: '2px',
    textAlign: 'right',
    padding: '0.2em 1em',
    fontWeight: 'bold',
    fontSize: '11px',
    color: '#4c4c4c',
  },
  checkboxAgreement: {
    '& span': {
      fontWeight: 'bold',
    },
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#f8f8f8',
    textAlign: 'center',
    color: '#555555',
  },
  body: {
    color: '#555555',
  },
}))(TableCell);

class SpeakerSubmissionForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:600px)').matches,
      isForeigner: '',

      //userInput
      country: '',
      firstName: '',
      lastName: '',
      affiliation: '',
      email: '',
      countryCode: '',
      phoneNumber: '',
      lang: 'eng',

      //bank
      accountHolder: '',
      bank: '',
      bankAccount: '',

      //lectureNote
      session: '',
      noteTitle: '',
      noteContent: '',
      prenoteContent: '',
      noteTitleCnt: 0,
      paragraphCnt: 0,
      noteContentCnt: 0,

      //file data
      cvfile: '',
      figures: [],
      figuresMemo: ['', '', '', '', '', ''],
      setOfFigures: 6,

      isUseLaptop: false,
      check1: false,
      check2: false,
      check2None: false,
      check3: false,
      check3None: false,
      checkVod: false,
      checkVodNone: false,

      isSubmitting: false,
    };

    this.refInputCountry = React.createRef();
    this.refInputFirstName = React.createRef();
    this.refInputLastName = React.createRef();
    this.refInputAffiliation = React.createRef();
    this.refInputEmail = React.createRef();
    this.refInputCountryCode = React.createRef();
    this.refInputPhone = React.createRef();
    this.refInputCV = React.createRef();
    this.refInputSession = React.createRef();
    this.refInputTitle = React.createRef();
    this.refInputAccountHolder = React.createRef();
    this.refInputBank = React.createRef();
    this.refInputAccount = React.createRef();

    this.handleState = this.handleState.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeNum = this.handleChangeNum.bind(this);
    this.handleChangeImg = this.handleChangeImg.bind(this);
    this.clickUploadImg = this.clickUploadImg.bind(this);
    this.delayEvent = this.delayEvent.bind(this);
    this.handleFigureMemo = this.handleFigureMemo.bind(this);
    this.downloadImg = this.downloadImg.bind(this);
  }

  componentDidMount() {
    if (this.props.mode && this.props.mode === 'write') {
      this.getUserInfo();
    }
    this.getUserCountryInfo();
    this.setNumFigures();

    const lang = sessionStorage.getItem('_in_country');

    if (!this.props.isAdmin) {
      if (lang && lang.indexOf('Korea') === 0) this.setState({ lang: 'kor' });
    }
  }

  getUserInfo() {
    axiosInstance.get(`${WEB_API}/user/info?eventId=${EVENT_ID}&userId=${getUserID()}`).then((res) => {
      if (res.data && res.data.Item) {
        const info = res.data.Item;
        let hp = '';
        let buff = info.hp.split('-');
        // 국적, 이름, 소속, 이메일, 폰번호
        for (let i = 1; i < buff.length; i++) {
          hp += `${buff[i]}`;
        }
        this.setState({
          country: info.country,
          firstName: info.firstName,
          lastName: info.lastName,
          affiliation: info.positionEn,
          email: info.email,
          countryCode: buff[0].replace(/\D/g, ''),
          phoneNumber: hp,
        });
      }
    });
  }

  getUserCountryInfo() {
    const country = sessionStorage.getItem('_in_country');
    if (country === 'Korea, Republic of') {
      this.setState({ isForeigner: 'N' });
    } else {
      this.setState({ isForeigner: 'Y' });
    }
  }

  setNumFigures() {
    let buff = [];
    let _buff = [];
    for (let i = 0; i < Number(this.state.setOfFigures); i++) {
      buff.push('');
      _buff.push('');
    }
    this.setState({ figures: buff, figuresMemo: _buff }, () => {
      if (this.props.mode && this.props.mode === 'modify') {
        this.getData();
      }
    });
  }

  getData() {
    if (this.props.data) {
      // console.log('props: ', this.props.data);
      this.setData(this.props.data);
    } else {
      axiosInstance.get(`${WEB_API}/speaker/info?eventId=${EVENT_ID}&speakerId=${this.props.abstractId}`).then((res) => {
        if (res.data.Item) {
          // console.log('axios: ', res.data.Item);
          this.setData(res.data.Item);
          if (this.props.isAdmin) {
            if (res.data.Item.country.indexOf('Korea') !== -1) this.setState({ lang: 'kor' });
            else this.setState({ lang: 'eng' });
          }
        }
      });
    }
  }

  setData(_data) {
    for (const [key, value] of Object.entries(_data)) {
      if (key === 'noteTitle') {
        this.setState({ noteTitle: value, noteTitleCnt: titleCounter(value) });
      }
      if (key === 'noteContent') {
        this.setState({ noteContent: value, noteContentCnt: wordCounter(value), paragraphCnt: paragraphCounter(value) });
      }
      if (
        key === 'figures1' ||
        key === 'figures2' ||
        key === 'figures3' ||
        key === 'figures4' ||
        key === 'figures5' ||
        key === 'figures6'
      ) {
        let buff = this.state.figures;
        for (let i = 0; i < this.state.figures.length; i++) {
          if (Number(key.substr(7)) - 1 === i) {
            buff[i] = value;
          }
        }
        this.setState(() => ({ figures: buff }));
      }
      if (
        key === 'figuresMemo1' ||
        key === 'figuresMemo2' ||
        key === 'figuresMemo3' ||
        key === 'figuresMemo4' ||
        key === 'figuresMemo5' ||
        key === 'figuresMemo6'
      ) {
        let _buff = this.state.figuresMemo;
        for (let i = 0; i < this.state.figuresMemo.length; i++) {
          if (Number(key.substr(11)) - 1 === i) {
            _buff[i] = value;
          }
        }
        this.setState(() => ({ figuresMemo: _buff }));
      }
      if (
        key === 'country' ||
        key === 'firstName' ||
        key === 'lastName' ||
        key === 'affiliation' ||
        key === 'email' ||
        key === 'countryCode' ||
        key === 'phoneNumber' ||
        key === 'session' ||
        key === 'cvfile' ||
        key === 'createdAt' ||
        key === 'writer' ||
        key === 'accountHolder' ||
        key === 'bank' ||
        key === 'bankAccount'
      ) {
        this.setState(() => ({ [key]: value }));
      }
      if (key === 'isAgree' && value === 'true') {
        this.setState(() => ({ [key]: true }));
      }
      if (key === 'isUseLaptop' && value === 'true') {
        this.setState(() => ({ [key]: true }));
      }
      if (key === 'check1' && value === 'true') {
        this.setState({ [key]: true });
      }
      if (key === 'check2' && value === 'true') {
        this.setState({ [key]: true });
      }
      if (key === 'check2None' && value === 'true') {
        this.setState({ [key]: true });
      }
      if (key === 'check3' && value === 'true') {
        this.setState({ [key]: true });
      }
      if (key === 'check3None' && value === 'true') {
        this.setState({ [key]: true });
      }
      if (key === 'checkVod' && value === 'true') {
        this.setState({ [key]: true });
      }
      if (key === 'checkVodNone' && value === 'true') {
        this.setState({ [key]: true });
      }
    }
  }

  handleChange(e, type) {
    this.setState({ [type]: e.target.value });
  }

  handleState = (type, value) => {
    this.setState((prevState) => ({ [type]: value }));
  };

  handleSelectCountry(e) {
    this.setState({ country: e.target.value }, () => {
      CountryList.forEach((country) => {
        if (country.name === this.state.country) {
          this.setState({ countryCode: country.dialingCode });
        }
      });
    });
  }

  handleSelect(e, key) {
    this.setState({ [key]: e.target.value });
  }

  handleChangeTitle = (e) => {
    if (titleCounter(e.target.value) <= 30) {
      this.setState({ noteTitle: e.target.value, noteTitleCnt: wordCounter(e.target.value) });
    } else {
      swal('Title cannot over 30 words');
      return false;
    }
  };

  handleChangeNum(e, type) {
    // const re = /^[0-9\b]{0,}$/;
    const re = /^[0-9\b]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      this.setState({ [type]: e.target.value });
    }
  }

  //이미지 첨부 버튼 클릭
  clickUploadImg(event, type) {
    event.preventDefault();
    // this.imgPicker.current.click();
    document.getElementById(`${type}`).click();
  }

  //input 태그 -> 실제로 이미지 바꾸는 코드
  handleChangeImg = async (event, type) => {
    if (event.target.files[0]) {
      const targetFile = event.target.files[0];
      let buff = this.state.figures;
      await readFile(targetFile)
        .then((file) => {
          if (type !== 'cvfile') {
            for (let i = 0; i < buff.length; i++) {
              if (Number(type) === i) {
                buff[i] = targetFile;
              }
            }
            this.setState({ figures: buff });
          } else {
            this.setState({ cvfile: targetFile });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  deleteImg(_id, delItem) {
    const items = this.state.figures;
    const memoArr = this.state.figuresMemo;
    if (delItem.size) {
      items.splice(_id, 1, '');
      memoArr.splice(_id, 1, '');
      this.setState({ figures: items, figuresMemo: memoArr });
    } else {
      swal({
        text: 'Are you sure to delete image?',
        buttons: true,
      }).then((willDelete) => {
        if (willDelete) {
          axiosInstance
            .post(`${WEB_API}/speaker/img`, {
              evt: EVENT_ID,
              speakerId: this.props.abstractId,
              delKey: 'figures' + (_id + 1),
              delPath: this.state.figures[_id].path,
            })
            .then((res) => {
              items.splice(_id, 1, '');
              memoArr.splice(_id, 1, '');
              this.setState({ figures: items, figuresMemo: memoArr });
            })
            .catch((err) => {
              console.error(err);
            });
        }
      });
    }
  }

  deleteCvfile() {
    if (this.state.cvfile.size) {
      this.setState({ cvfile: '' });
    } else {
      swal({
        text: 'Are you sure to delete file?',
        buttons: true,
      }).then((willDelete) => {
        if (willDelete) {
          axiosInstance
            .post(`${WEB_API}/speaker/img`, {
              evt: EVENT_ID,
              speakerId: this.props.abstractId,
              delKey: 'cvfile',
              delPath: this.state.cvfile.path,
            })
            .then(() => {
              this.setState({ cvfile: '' });
            })
            .catch((_err) => {
              console.error(_err);
            });
        }
      });
    }
  }

  handleFigureMemo = (event, idx) => {
    let buff = this.state.figuresMemo;
    const val = event.target.value;
    for (let i = 0; i < buff.length; i++) {
      if (Number(idx) === i) {
        buff[i] = val;
      }
    }
    this.setState({ figuresMemo: buff });
  };

  async delayEvent(event, editor, type) {
    const data = editor.getData();
    //단어 수 계산
    let buffCnt = wordCounter(data);
    if (buffCnt > 350) {
      swal('Word cannot over 350 words');
      this.handleState('noteContent', this.state.prenoteContent);
      if (editor) {
        editor.setData(this.state.prenoteContent);
      }
      return false;
    }

    this.handleState('prenoteContent', data);
    this.handleState('noteContent', data);
    this.handleState('paragraphCnt', paragraphCounter(data));
    this.handleState('noteContentCnt', wordCounter(data));
  }

  onSubmit = () => {
    if (!emailValidation(this.state.email)) {
      focusElementRef('Email address is not valid.', this.refInputEmail);
      return;
    }
    if (this.state.country === 'Korea, Republic of') {
      if (!krMobileValidation(this.state.phoneNumber)) {
        focusElementRef('Phone number is not valid', this.refInputPhone);
        return;
      }
    } else {
      if (!/(\d{7,})/gi.test(this.state.phoneNumber)) {
        focusElementRef('Phone number is not valid', this.refInputPhone);
        return;
      }
    }

    this.setState({ isSubmitting: true });

    speakerAction(this.state, this.props.mode, this.props.abstractId)
      .then((result) => {
        console.log(result, 'result');
        if (this.props.mode === 'modify') {
          if (this.props.isRegister) {
            swal('Your abstract submission is temporary saved', {
              icon: 'success',
            }).then(() => {
              this.props.handleState('abstractId', result.data.Attributes.id);
              this.props.handleState('data', result.data.Attributes);
              this.props.handleState('formState', 'confirm');
              this.setStateInitialize();
            });
          } else if (this.props.isMypage) {
            const msg =
              this.props.data.status && this.props.data.status === 'Complete'
                ? 'Your abstract submission is completed.'
                : 'Your abstract submission is temporary saved.';
            swal(msg, {
              icon: 'success',
            }).then(() => {
              this.props.handleState('paperId', result.data.Attributes.id);
              this.props.handleState('paperInfo', result.data.Attributes);
              this.props.handleState('showReview', true);
              this.props.handleState('showMod', false);
              // {
              //   this.props.data.status &&
              //     this.props.data.status === 'Complete' &&
              //     // 등록완료 메일
              //     axiosInstance
              //       .post(
              //         `${WEB_API}/${'speaker'}/${'speaker'}SubmitEmail?evt=${EVENT_ID}&${'speaker'}Id=${
              //           result.data.Attributes.id
              //         }&toEmail=${this.state.email}&templateName=${'SpeakerSubmitPRS2021'}&from=${F_EMAIL}`,
              //       )
              //       .then((response) => {
              //         if (response.status === 200) {
              //           console.log(response, 'mail send');
              //         }
              //       });
              // }

              // this.props.handleClose();
            });
          } else {
            // for Admin
            swal('[Admin] modified successfully.', {
              icon: 'success',
            }).then(() => {
              // this.props.handleState('data', result.data.Attributes);

              this.closeForm();
            });
          }
        } else {
          swal('Your abstract submission is temporary saved.', {
            icon: 'success',
          }).then(() => {
            this.props.handleState('abstractId', result.data.Attributes.id);
            this.props.handleState('data', result.data.Attributes);
            this.props.handleState('formState', 'confirm');
            this.setStateInitialize();
          });
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.setState({ isSubmitting: false });
      });
  };

  setStateInitialize() {
    //eslint-disable-next-line
    for (const [key, value] of Object.entries(this.state)) {
      if (key === 'setOfFigures') {
        this.setState({ [key]: 4 });
      } else if (key === 'noteTitleCnt' || key === 'paragraphCnt' || key === 'noteContentCnt') {
        this.setState({ [key]: 0 });
      } else if (key === 'figures' || key === 'figuresMemo') {
        this.setState({ [key]: [] });
      } else if (key === 'isAgree') {
        this.setState({ [key]: false });
      } else {
        this.setState({ [key]: '' });
      }
    }
  }

  closeForm() {
    if (this.props.isPop) {
      this.props.handleClose();
    } else {
      this.props.movePage('/mypage', {
        sidx: 4,
      });
    }
  }

  downloadImg(imgSrc) {
    var image = new Image();
    image.crossOrigin = 'anonymous';
    image.src = imgSrc;
    var fileName = image.src.split('/').pop();
    image.onload = function () {
      var canvas = document.createElement('canvas');
      canvas.width = this.width;
      canvas.height = this.height;
      canvas.getContext('2d').drawImage(this, 0, 0);
      if (window.navigator && window.navigator.msSaveBlob) {
        const dataURLtoBlob = () => {
          var arr = canvas.toDataURL().split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          var blobObj = new Blob([u8arr], {
            type: mime,
          });
          return blobObj;
        };
        window.navigator.msSaveBlob(dataURLtoBlob(), fileName);
      } else {
        var link = document.createElement('a');
        link.href = canvas.toDataURL();
        link.download = fileName;
        link.click();
      }
    };
  }

  render() {
    const { classes, mode, theme } = this.props;
    // console.log(this.state.country, 'country');
    // console.log(this.state.firstName, 'firstName');
    // console.log(this.state.lastName, 'lastName');
    // console.log(this.state.affiliation, 'affiliation');
    // console.log(this.state.email, 'email');
    // console.log(this.state.countryCode, 'countryCode');
    // console.log(this.state.phoneNumber, 'phoneNumber');
    // console.log(this.state.cvfile, 'cvfile');
    // console.log(this.state.session, 'session');
    // console.log(this.state.noteTitle, 'noteTitle');
    // console.log(this.state.noteContent, 'noteContent');
    // console.log(this.state.check1, 'check1');
    // console.log(this.state.check2, 'check2');
    // console.log(this.state.checkVod, 'checkVod');
    // console.log(this.state.accountHolder, 'accountHolder');
    // console.log(this.state.bank, 'bank');
    // console.log(this.state.bankAccount, 'bankAccount');
    // console.log(this.state.check3None, 'check3None');
    // console.log(this.state.check3, 'check3');
    console.log(this.state.isUseLaptop, 'isUseLaptop');
    return (
      <>
        <div style={this.state.lang === 'kor' ? {} : { width: '100%' }}>
          <Grid
            item
            xs={this.props.isPop ? 12 : 8}
            style={
              this.props.isAdmin
                ? navigator.userAgent.indexOf('Trident') !== -1
                  ? { padding: 20, minWidth: '960px' }
                  : { padding: 20 }
                : { padding: 0, margin: '0 auto' }
            }
          >
            <Typography align="right">
              * Fields marked with an asterisk(<span className={classes.asteriskMark}>*</span>) are required.
            </Typography>
            <Table /* className={classes.table} */>
              <TableBody>
                <TableRow>
                  <StyledTableCell component="th" width="25%">
                    <span className={classes.asteriskMark}>*</span> Country
                  </StyledTableCell>
                  <StyledTableCell component="td" width="75%">
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <FormControl variant="outlined" fullWidth size={'small'}>
                          <Select
                            id="country-select"
                            required
                            displayEmpty
                            value={this.state.country}
                            onChange={(e) => this.handleSelectCountry(e)}
                            inputRef={this.refInputCountry}
                          >
                            <MenuItem value={''}>SELECT</MenuItem>
                            {CountryList.map((country, cIdx) => {
                              return (
                                <MenuItem value={country.name} key={`country-select-item-${cIdx}`}>
                                  {country.name}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </StyledTableCell>
                </TableRow>
                <TableRow>
                  <StyledTableCell component="th" width="25%">
                    <span className={classes.asteriskMark}>*</span> Name
                  </StyledTableCell>
                  <StyledTableCell component="td" width="75%">
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <TextField
                          id="first-name-input"
                          placeholder="First Name"
                          variant="outlined"
                          fullWidth
                          size={'small'}
                          value={this.state.firstName}
                          onChange={(e) => this.handleChange(e, 'firstName')}
                          inputRef={this.refInputFirstName}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          id="last-name-input"
                          placeholder="Last Name(Family Name)"
                          variant="outlined"
                          fullWidth
                          size={'small'}
                          value={this.state.lastName}
                          onChange={(e) => this.handleChange(e, 'lastName')}
                          inputRef={this.refInputLastName}
                        />
                      </Grid>
                    </Grid>
                  </StyledTableCell>
                </TableRow>
                <TableRow>
                  <StyledTableCell component="th" width="25%">
                    <span className={classes.asteriskMark}>*</span> Affiliation
                  </StyledTableCell>
                  <StyledTableCell component="td" width="75%">
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <TextField
                          id="affiliation-input"
                          variant="outlined"
                          fullWidth
                          size={'small'}
                          value={this.state.affiliation}
                          onChange={(e) => this.handleChange(e, 'affiliation')}
                          inputRef={this.refInputAffiliation}
                        />
                      </Grid>
                    </Grid>
                  </StyledTableCell>
                </TableRow>
                <TableRow>
                  <StyledTableCell component="th" width="25%">
                    <span className={classes.asteriskMark}>*</span> Email
                  </StyledTableCell>
                  <StyledTableCell component="td" width="75%">
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <TextField
                          id="outlined-basic"
                          variant="outlined"
                          fullWidth
                          size={'small'}
                          value={this.state.email}
                          onChange={(e) => this.handleChange(e, 'email')}
                          inputRef={this.refInputEmail}
                          disabled
                        />
                      </Grid>
                    </Grid>
                  </StyledTableCell>
                </TableRow>
                <TableRow>
                  <StyledTableCell component="th" width="25%">
                    <span className={classes.asteriskMark}>*</span> Cell Phone No
                  </StyledTableCell>
                  <StyledTableCell component="td" width="75%">
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <div style={{ display: 'flex' }}>
                          <div style={{ textAlign: 'center' }}>
                            <InputLabel htmlFor="country-code-input" className={classes.inputLabelText}>
                              +Country Code
                            </InputLabel>
                            <TextField
                              id="country-code-input"
                              variant="outlined"
                              fullWidth
                              size={'small'}
                              value={this.state.countryCode}
                              onChange={(e) => this.handleChange(e, 'countryCode')}
                              inputRef={this.refInputCountryCode}
                            />
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={{ width: '0.5em' }}></span>
                          </div>
                          <div style={{ textAlign: 'center' }}>
                            <InputLabel htmlFor="phone-number-input" className={classes.inputLabelText}>
                              Phone Number
                            </InputLabel>
                            <TextField
                              id="phone-number-input"
                              variant="outlined"
                              fullWidth
                              size={'small'}
                              value={this.state.phoneNumber}
                              onChange={(e) => this.handleChangeNum(e, 'phoneNumber')}
                              inputRef={this.refInputPhone}
                            />
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                  </StyledTableCell>
                </TableRow>
                <TableRow>
                  <StyledTableCell component="th" width="25%">
                    {/* <span className={classes.asteriskMark}>*</span> */}
                    CV Upload
                  </StyledTableCell>
                  <StyledTableCell component="td" width="75%">
                    <Grid container spacing={1} alignItems="center">
                      <Grid item xs={10}>
                        <input
                          type="file"
                          // ref={this.imgPicker}
                          id={'cv-file-picker'}
                          accept=".doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                          style={{ display: 'none' }}
                          onChange={(e) => this.handleChangeImg(e, 'cvfile')}
                        />
                        <TextField
                          id="cv-file-input"
                          variant="outlined"
                          fullWidth
                          size={'small'}
                          placeholder={'Select file'}
                          value={this.state.cvfile.name ? this.state.cvfile.name : ''}
                          disabled
                          inputRef={this.refInputCV}
                        />
                      </Grid>
                      <Grid item xs={1} style={{ textAlign: 'center' }}>
                        <IconButton
                          variant="contained"
                          color={'primary'}
                          size={'small'}
                          onClick={(e) => this.clickUploadImg(e, 'cv-file-picker')}
                          style={{
                            width: '100%',
                            backgroundColor: theme.palette.primary.main,
                            color: '#fff',
                            borderRadius: '4px',
                            padding: mode === 'modify' ? theme.spacing(1, 1.2) : theme.spacing(1, 1.5),
                          }}
                        >
                          <SearchIcon />
                        </IconButton>
                      </Grid>
                      <Grid item xs={1} style={{ textAlign: 'center' }}>
                        <IconButton
                          variant="contained"
                          color={'primary'}
                          size={'small'}
                          disabled={!this.state.cvfile.name || this.state.cvfile === ''}
                          onClick={(e) => this.deleteCvfile()}
                          style={{
                            width: '100%',
                            backgroundColor: !this.state.cvfile.name || this.state.cvfile === '' ? 'gray' : theme.palette.primary.main,
                            color: '#fff',
                            borderRadius: '4px',
                            padding: mode === 'modify' ? theme.spacing(1, 1.2) : theme.spacing(1, 1.5),
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                    <div style={{ display: 'flex', alignItems: 'center', paddingTop: '0.5em' }}>
                      <Typography style={{ marginRight: '1em', fontSize: '1em' }}>* PRS KOREA 2022 CV Form Download</Typography>
                      <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        disableElevation
                        onClick={(e) => {
                          window.open('https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/Curriculum+Vitae_PRS+KOREA+2022.docx');
                        }}
                        style={{ color: '#fff', textTransform: 'none' }}
                      >
                        CV Form Download
                      </Button>
                    </div>
                  </StyledTableCell>
                </TableRow>
                <TableRow>
                  <StyledTableCell component="th" colSpan={2} style={{ textAlign: 'center', color: '#777777' }}>
                    Abstract
                  </StyledTableCell>
                </TableRow>
                <TableRow>
                  <StyledTableCell component="th" width="25%">
                    <span className={classes.asteriskMark}>*</span> Session
                  </StyledTableCell>
                  <StyledTableCell component="td" width="75%">
                    <FormControl variant="outlined" fullWidth size={'small'}>
                      {/* <Select
                        id="session-select"
                        required
                        displayEmpty
                        value={this.state.session}
                        onChange={(e) => this.handleSelect(e, 'session')}
                        inputRef={this.refInputSession}
                      >
                        <MenuItem value={''}>SELECT</MenuItem>
                        {SessionList.map((session, sIdx) => {
                          return (
                            <MenuItem value={session.name} key={`session-select-item-${sIdx}`}>
                              {session.name}
                            </MenuItem>
                          );
                        })}
                      </Select> */}
                      {/* {this.props.mode === 'write' || (this.props.mode === 'modify' && this.state.session) ? ( */}
                      <Autocomplete
                        id="session-select"
                        value={this.state.session}
                        options={SessionList}
                        getOptionLabel={(option) => (option.name ? option.name : this.state.session ? this.state.session : '')}
                        getOptionSelected={(option, value) => {
                          if (this.props.mode === 'modify' && option.name === value) {
                            return true;
                          }
                        }}
                        style={{ width: 300 }}
                        renderInput={(params) => <TextField {...params} label="SELECT" variant="outlined" />}
                        onChange={(event, newValue) => {
                          newValue ? this.setState({ session: newValue.name }) : this.setState({ session: '' });
                        }}
                      />
                      {/* ) : null} */}
                    </FormControl>
                  </StyledTableCell>
                </TableRow>
                <TableRow>
                  <StyledTableCell component="th" width="25%">
                    <span className={classes.asteriskMark}>*</span> Title
                  </StyledTableCell>
                  <StyledTableCell component="td" width="75%">
                    <TextField
                      id="lecture-note-title-input"
                      variant="outlined"
                      fullWidth
                      size={'small'}
                      value={this.state.noteTitle}
                      onChange={this.handleChangeTitle}
                      inputRef={this.refInputTitle}
                    />
                    <Typography className={classes.tableInsideText}> ({this.state.noteTitleCnt}) / 30 words</Typography>
                    <Typography className={classes.tableInsideText}>* Less than 30words including Spaces in English.</Typography>
                  </StyledTableCell>
                </TableRow>
                <TableRow>
                  <StyledTableCell component="th" width="25%">
                    <span className={classes.asteriskMark}>*</span> Body
                  </StyledTableCell>
                  <StyledTableCell component="td" width="75%">
                    <Typography className={classes.tableInsideText}>
                      ※ The abstract must not exceed 350 words. (All abstracts words : {this.state.noteContentCnt} / 350)
                    </Typography>
                    <Editor
                      data={
                        this.props.mode === 'write'
                          ? this.state.noteContent
                          : this.props.isAdmin
                          ? this.props.infoData.noteContent
                          : this.props.data.noteContent
                      }
                      paragraphCnt={this.state.paragraphCnt}
                      wordCnt={this.state.noteContentCnt}
                      delayEvent={this.delayEvent}
                      type={'note'}
                    />
                  </StyledTableCell>
                </TableRow>
                <TableRow
                // style={this.state.lang !== 'kor' ? { display: 'none' } : {}}
                >
                  <StyledTableCell component="th" width="25%">
                    <span className={classes.asteriskMark}>*&nbsp;</span>
                    {this.state.lang !== 'kor' ? 'Use own your Laptop' : '개인노트북 사용 여부'}
                  </StyledTableCell>
                  <StyledTableCell component="td" width="75%">
                    <RadioGroup
                      value={this.state.isUseLaptop}
                      onChange={(e) => {
                        const val = e.target.value === 'true' ? true : false;
                        this.setState({ isUseLaptop: val });
                      }}
                      style={{ flexDirection: 'row' }}
                    >
                      <FormControlLabel value={true} control={<Radio />} label={this.state.lang !== 'kor' ? 'Use' : '사용'} />
                      <FormControlLabel value={false} control={<Radio />} label={this.state.lang !== 'kor' ? 'Not Used' : '미사용'} />
                    </RadioGroup>
                    <div style={{ color: '#f00', lineHeight: 1.6 }}>
                      {this.state.lang !== 'kor' ? (
                        <div>
                          ※ To use personal computer for presentation will not be allowed. <br />
                          ※ If you use personal laptop, please prepare the laptop adaptor by yourself. <br />※ Please bring your USB stick
                          to upload your presentation file in the Preview Room.
                        </div>
                      ) : (
                        <div>
                          ※ 오프라인으로 진행되는 학술대회 특성상 개인노트북 사용을 지양합니다.
                          <br />
                          ※ 개인노트북 사용할 경우, 노트북 젠더는 개별로 준비하여 주시기 바랍니다.
                          <br />※ 최종 발표파일을 USB에 넣어 행사당일 Preview Room으로 접수하여 주시기 바랍니다.
                        </div>
                      )}
                    </div>
                  </StyledTableCell>
                </TableRow>
                {this.state.country === 'Korea, Republic of' && (
                  <TableRow style={this.state.lang !== 'kor' ? { display: 'none' } : {}}>
                    <StyledTableCell component="th" width="25%">
                      <span className={classes.asteriskMark}>*</span> 은행정보
                    </StyledTableCell>
                    <StyledTableCell component="td" width="75%">
                      <Grid container spacing={1}>
                        <Grid item xs={3}>
                          <TextField
                            id="accountHolder-input"
                            label="예금주"
                            placeholder="예금주"
                            variant="outlined"
                            fullWidth
                            size={'small'}
                            value={this.state.accountHolder}
                            onChange={(e) => this.handleChange(e, 'accountHolder')}
                            inputRef={this.refInputAccountHolder}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <TextField
                            id="bank-input"
                            label="은행명"
                            placeholder="은행명"
                            variant="outlined"
                            fullWidth
                            size={'small'}
                            value={this.state.bank}
                            onChange={(e) => this.handleChange(e, 'bank')}
                            inputRef={this.refInputBank}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <TextField
                            id="bankAccount-input"
                            label="계좌번호"
                            placeholder="계좌번호"
                            variant="outlined"
                            fullWidth
                            size={'small'}
                            value={this.state.bankAccount}
                            onChange={(e) => this.handleChangeNum(e, 'bankAccount')}
                            inputRef={this.refInputAccount}
                          />
                        </Grid>

                        <Grid>
                          <Typography style={{ color: '#f00', fontSize: 14, padding: '8px 0' }}>
                            ※ 좌장 및 연자료 지급을 위한 정보이며, 입력 후 오타가 없는지 확인하시기 바랍니다.
                          </Typography>
                        </Grid>
                      </Grid>
                    </StyledTableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Grid>
          <Grid
            item
            xs={this.props.isPop ? 12 : 8}
            style={
              this.props.isAdmin
                ? navigator.userAgent.indexOf('Trident') !== -1
                  ? { padding: 20, minWidth: '960px' }
                  : { padding: 20 }
                : { padding: 0, margin: '0 auto' }
            }
          >
            <FiguresUploadForm
              setOfFigures={this.state.setOfFigures}
              handleChangeImg={this.handleChangeImg.bind(this)}
              clickUploadImg={this.clickUploadImg.bind(this)}
              deleteImg={this.deleteImg.bind(this)}
              figures={this.state.figures}
              figuresMemo={this.state.figuresMemo}
              handleFigureMemo={this.handleFigureMemo}
              mode={mode}
            />
          </Grid>
          <Grid
            item
            xs={this.props.isPop ? 12 : 8}
            style={
              this.props.isAdmin
                ? navigator.userAgent.indexOf('Trident') !== -1
                  ? { padding: 20, minWidth: '960px' }
                  : { padding: 20 }
                : { padding: 0, margin: '0 auto' }
            }
          >
            <div style={{ height: '30px' }} />
          </Grid>

          <Grid
            item
            xs={this.props.isPop ? 12 : 8}
            style={
              this.props.isAdmin
                ? navigator.userAgent.indexOf('Trident') !== -1
                  ? { padding: 20, minWidth: '960px' }
                  : { padding: 20 }
                : { padding: 0, margin: '0 auto' }
            }
          >
            {this.state.lang !== 'kor' ? (
              <>
                {/* <div>
                  <Typography className={classes.title} gutterBottom>
                    VOD Replay Agreement
                  </Typography>
                  <AgreementDiv noneHeight={true}>
                    <div>
                      <p>I agree that a VOD replay service can be provided to designated KSPRS members for a month.</p>
                      <FormControl style={{ display: 'block' }}>
                        <FormControlLabel
                          className={classes.checkboxAgreement}
                          labelPlacement="start"
                          label="I agree."
                          control={
                            <Checkbox
                              color="primary"
                              checked={this.state.checkVod}
                              onChange={(e) => {
                                this.setState({ checkVod: e.target.checked, checkVodNone: !e.target.checked });
                              }}
                            />
                          }
                        />
                        <FormControlLabel
                          className={classes.checkboxAgreement}
                          labelPlacement="start"
                          label="I do not agree."
                          control={
                            <Checkbox
                              color="primary"
                              checked={this.state.checkVodNone}
                              onChange={(e) => {
                                this.setState({ checkVodNone: e.target.checked, checkVod: !e.target.checked });
                              }}
                            />
                          }
                        />
                      </FormControl>
                    </div>
                  </AgreementDiv>
                </div> */}
                {/* <div>
                  <Typography className={classes.title} gutterBottom>
                    {'<'}E-Learning Speaker Release Agreement{'>'}
                  </Typography>
                  <Typography className={classes.subTitle}>
                    The Korean Society of Plastic and Reconstructive Surgeons intends to provide the lectures or presentations on
                    cutting-edge knowledge created by speakers through the homepage in a form of E-Learning in order to enhance the capacity
                    of regular and associate members and activate the homepage through E-Learning. Speakers are requested to read the
                    statements below and indicate whether they agree to each statement by checking the relevant box.
                  </Typography>
                  <AgreementDiv noneHeight={true}>
                    <div>
                      <p>
                        (1) As the Speaker, I warrant that the materials I have submitted do not infringe upon the copyrights of others.
                      </p>
                      <br />
                      <FormControl>
                        <FormControlLabel
                          className={classes.checkboxAgreement}
                          labelPlacement="start"
                          label="I warrant that the above statement is true."
                          control={
                            <Checkbox
                              color="primary"
                              checked={this.state.check1}
                              onChange={(e) => {
                                this.setState({ check1: e.target.checked });
                              }}
                            />
                          }
                        />
                      </FormControl>
                    </div>
                    <br />
                    <div>
                      <p>
                        (2) I agree that the lecture videos and related materials I have submitted may be posted online in the E-Learning
                        system of the homepage of the Society and may be made available as streaming video files free of charge to the
                        members of the Society who currently have membership status through membership registration on the homepage. I also
                        agree that the above mentioned materials may be edited and revised in a form suitable for E-Learning. Further, I
                        agree that I shall not assert copyright infringement claims against the Society and its members in connection with
                        the operation of E-Learning specified herein.
                      </p>
                      <br />
                      <FormControl style={{ display: 'block' }}>
                        <FormControlLabel
                          className={classes.checkboxAgreement}
                          labelPlacement="start"
                          label="I agree to each of the above statements."
                          control={
                            <Checkbox
                              color="primary"
                              checked={this.state.check2}
                              onChange={(e) => {
                                this.setState({ check2: e.target.checked, check2None: !e.target.checked });
                              }}
                            />
                          }
                        />
                        <FormControlLabel
                          className={classes.checkboxAgreement}
                          labelPlacement="start"
                          label="I do not agree."
                          control={
                            <Checkbox
                              color="primary"
                              checked={this.state.check2None}
                              onChange={(e) => {
                                this.setState({ check2None: e.target.checked, check2: !e.target.checked });
                              }}
                            />
                          }
                        />
                      </FormControl>
                    </div>
                    <br />
                    <div>
                      <p>
                        (3) I warrant that the lecture videos and related materials I have submitted do not contain any personal information
                        or pictures of third parties. I further warrant that I have obtained and kept written informed consent from the
                        individual for personal information or photographs of a third party inevitably included in the submitted materials.
                      </p>
                      <FormControl style={{ display: 'block' }}>
                        <FormControlLabel
                          className={classes.checkboxAgreement}
                          labelPlacement="start"
                          label="I have received written informed consent."
                          control={
                            <Checkbox
                              color="primary"
                              checked={this.state.check3}
                              onChange={(e) => {
                                this.setState({ check3: e.target.checked, check3None: !e.target.checked });
                              }}
                            />
                          }
                        />
                        <FormControlLabel
                          className={classes.checkboxAgreement}
                          labelPlacement="start"
                          label="Not relevant"
                          control={
                            <Checkbox
                              color="primary"
                              checked={this.state.notReceived}
                              onChange={(e) => {
                                this.setState({ check3None: e.target.checked, check3: !e.target.checked });
                              }}
                            />
                          }
                        />
                      </FormControl>
                    </div>
                  </AgreementDiv>
                </div> */}
              </>
            ) : (
              <React.Fragment>
                {/* <div style={{ marginTop: '1em', marginBottom: '1rem' }}>
                  <Typography className={classes.title} gutterBottom>
                    VOD 다시보기 동의서
                  </Typography>
                  <AgreementDiv noneHeight={true}>
                    <div>
                      <p>
                        온라인 학술대회로 진행되는 PRS KOREA 2022은 실시간 송출되는 강의 및 Q&A 영상의 저작권은 대한성형외과학회에 귀속되며,
                        정해진 회원들을 대상으로 일정기간 다시보기 서비스를 제공할 수 있음에 동의 합니다.
                      </p>
                      <FormControl style={{ display: 'block' }}>
                        <FormControlLabel
                          className={classes.checkboxAgreement}
                          labelPlacement="start"
                          label="동의합니다."
                          control={
                            <Checkbox
                              color="primary"
                              checked={this.state.checkVod}
                              onChange={(e) => {
                                this.setState({ checkVod: e.target.checked, checkVodNone: !e.target.checked });
                              }}
                            />
                          }
                        />
                        <FormControlLabel
                          className={classes.checkboxAgreement}
                          labelPlacement="start"
                          label="동의하지 않습니다."
                          control={
                            <Checkbox
                              color="primary"
                              checked={this.state.checkVodNone}
                              onChange={(e) => {
                                this.setState({ checkVodNone: e.target.checked, checkVod: !e.target.checked });
                              }}
                            />
                          }
                        />
                      </FormControl>
                    </div>
                  </AgreementDiv>
                </div> */}
                {/* <div>
                  <Typography className={classes.title} gutterBottom>
                    E-Learning 동의서
                  </Typography>
                  <Typography className={classes.subTitle}>
                    대한성형외과학회는 연자께서 준비하신 최신 지견을 홈페이지를 통해 E-Learning 형태로 제공함으로써, 정회원 및 준회원들의
                    역량을 강화 하고 E-Learning을 통하여 홈페이지를 활성화하고자 합니다. <br />
                    연자는 E-Learning 자료를 제출하시기에 앞서 아래 사항을 확인하시고 동의여부 체크하여 주시기 바랍니다.
                  </Typography>
                  <AgreementDiv noneHeight={true}>
         
                    <div>
                      <p>(1) 연자가 제공한 자료는 타인의 저작권을 침해하지 않음을 확인합니다.</p>
                      <FormControl>
                        <FormControlLabel
                          className={classes.checkboxAgreement}
                          labelPlacement="start"
                          label="확인합니다."
                          control={
                            <Checkbox
                              color="primary"
                              checked={this.state.check1}
                              onChange={(e) => {
                                this.setState({ check1: e.target.checked });
                              }}
                            />
                          }
                        />
                      </FormControl>
                    </div>
                    <br />
                  
                    <div>
                      <p>
                        (2) 연자는 제공한 강의 동영상 및 관련 자료가 학회 홈페이지의 E-Learning 시스템에 게시되어, 홈페이지에 가입한 학회
                        회원에 대하여 무상으로 스트리밍 방식으로 제공되는 것에 동의합니다. 또한 위와 같은 자료가 E-Learning에 적합한
                        형식으로 편집 및 수정되는 것에 동의합니다. 연자는 위와 같은 E-Learning 운영에 관하여 학회 및 회원에 대하여 저작권
                        침해 등의 주장을 하지 아니할 것에 동의합니다.
                      </p>
                      <FormControl style={{ display: 'block' }}>
                        <FormControlLabel
                          className={classes.checkboxAgreement}
                          labelPlacement="start"
                          label="동의합니다."
                          control={
                            <Checkbox
                              color="primary"
                              checked={this.state.check2}
                              onChange={(e) => {
                                this.setState({ check2: e.target.checked, check2None: !e.target.checked });
                              }}
                            />
                          }
                        />
                        <FormControlLabel
                          className={classes.checkboxAgreement}
                          labelPlacement="start"
                          label="동의하지 않습니다."
                          control={
                            <Checkbox
                              color="primary"
                              checked={this.state.check2None}
                              onChange={(e) => {
                                this.setState({ check2None: e.target.checked, check2: !e.target.checked });
                              }}
                            />
                          }
                        />
                      </FormControl>
                    </div>
                    <br />
        
                    <div>
                      <p>
                        (3) 연자는 제공한 강의 동영상 및 관련 자료에 제3자의 개인정보 또는 초상이 포함되지 않았음을 확인합니다. 만약
                        부득의하게 제3자의 개인정보 또는 초상이 포함된 경우 해당 개인에게 별도의 서면 동의를 받아 보관하고 있음을
                        확인합니다.
                      </p>
                      <FormControl style={{ display: 'block' }}>
               
                        <FormControlLabel
                          className={classes.checkboxAgreement}
                          labelPlacement="start"
                          label="받았습니다."
                          control={
                            <Checkbox
                              color="primary"
                              checked={this.state.check3}
                              onChange={(e) => {
                                this.setState({ check3: e.target.checked, check3None: !e.target.checked });
                              }}
                            />
                          }
                        />
                    
                        <FormControlLabel
                          className={classes.checkboxAgreement}
                          labelPlacement="start"
                          label="해당사항 없음"
                          control={
                            <Checkbox
                              color="primary"
                              checked={this.state.check3None}
                              onChange={(e) => {
                                this.setState({ check3None: e.target.checked, check3: !e.target.checked });
                              }}
                            />
                          }
                        />
                      </FormControl>
                    </div>
                  </AgreementDiv>
                </div> */}
              </React.Fragment>
            )}
          </Grid>

          {/* <Grid
            item
            container
            xs={this.props.isPop ? 12 : 8}
            style={
              this.props.isAdmin
                ? navigator.userAgent.indexOf('Trident') !== -1
                  ? { padding: 20, minWidth: '960px' }
                  : { padding: 20 }
                : { padding: 0, margin: '0 auto' }
            }
            justifyContent="flex-end"
          >
            <div style={{ textAlign: 'right' }}>
              <Typography style={{ paddingRight: '1em' }}>
                {this.state.createdAt ? moment(this.state.createdAt).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')}
              </Typography>
            </div>
          </Grid> */}
          <Grid
            item
            xs={this.props.isPop ? 12 : 8}
            style={
              this.props.isAdmin
                ? navigator.userAgent.indexOf('Trident') !== -1
                  ? { padding: 20, minWidth: '960px' }
                  : { padding: 20 }
                : { padding: 0, margin: '0 auto' }
            }
          >
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <ConfirmButton
                color="primary"
                // size="large"
                // variant="contained"
                // disableElevation
                disabled={
                  this.state.lang !== 'kor'
                    ? this.state.country === '' ||
                      this.state.firstName === '' ||
                      this.state.lastName === '' ||
                      this.state.affiliation === '' ||
                      this.state.email === '' ||
                      this.state.countryCode === '' ||
                      this.state.phoneNumber === '' ||
                      // this.state.cvfile === '' ||
                      this.state.session === '' ||
                      this.state.noteTitle === ''
                    : // this.state.noteContent === '' ||
                      // (!this.state.checkVod && !this.state.checkVodNone)
                      // (!this.state.check3 && !this.state.check3None)
                      this.state.country === '' ||
                      this.state.firstName === '' ||
                      this.state.lastName === '' ||
                      this.state.affiliation === '' ||
                      this.state.email === '' ||
                      this.state.countryCode === '' ||
                      this.state.phoneNumber === '' ||
                      // this.state.cvfile === '' ||
                      this.state.session === '' ||
                      this.state.noteTitle === '' ||
                      this.state.noteContent === '' ||
                      // !this.state.check1 ||
                      // (!this.state.check2 && !this.state.check2None) ||
                      // (!this.state.check3 && !this.state.check3None) ||
                      // (!this.state.checkVod && !this.state.checkVodNone) ||
                      this.state.accountHolder === '' ||
                      this.state.bank === '' ||
                      this.state.bankAccount === ''
                }
                onClick={this.onSubmit}
              >
                {mode === 'write' || this.props.isRegister || !this.props.isMypage ? 'Temporary Save & Preview' : 'Modify'}
              </ConfirmButton>
              <div style={{ width: '20px' }} />
              <ConfirmButton
                size="large"
                variant="contained"
                disableElevation
                onClick={() => {
                  if (mode === 'modify') {
                    this.closeForm();
                  } else if (mode === 'write') {
                    this.props.moveBackPage();
                  }
                }}
              >
                Cancel
              </ConfirmButton>
            </div>
          </Grid>
        </div>
        {this.state.isSubmitting && (
          <div style={{ position: 'fixed', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
            <CircularProgress size={100} thickness={5} style={{ color: theme.palette.secondary.point }} />
          </div>
        )}
      </>
    );
  }
}

export default withStyles(styles, { withTheme: true })(SpeakerSubmissionForm);
